<ion-tabs>
  <ion-tab-bar slot="bottom">
    @for (tab of homeTabs; track tab) {
      <ion-tab-button tab="{{ tab.tab }}">
        <ion-icon name="{{ tab.icon }}"></ion-icon>
        {{ tab.label }}
      </ion-tab-button>
    }
  </ion-tab-bar>
</ion-tabs>
